import React, { createContext, useContext } from "react";

import useConnections from "../../hooks/useConnections";
import { AuthContext } from "../Auth/AuthContext";

const ConnectionsContext = createContext();

const ConnectionsProvider = ({ children }) => {
	const { user } = useContext(AuthContext);
	const accountKey = user?.companyId ? `${user.companyId}-${user.id}` : "";
	const { loading, connections } = useConnections(accountKey);

	return (
		<ConnectionsContext.Provider value={{ connections, loading }}>
			{children}
		</ConnectionsContext.Provider>
	);
};

export { ConnectionsContext, ConnectionsProvider };

